import { jsx as t } from "react/jsx-runtime";
import { ReachIcon as b, PersonIcon as S, OfflineIcon as h } from "../../icons/index.es.js";
import { memo as i, useMemo as D } from "react";
import { composeTrackId as l } from "../../utils/trackId.es.js";
import { SelectDropdown as R } from "../../atoms/SelectDropdown/SelectDropdown.es.js";
import { TALENT_DROPDOWN_VALUES as e } from "./TalentDropdown.types.es.js";
const n = {
  [e.agency]: "talent-option-agency",
  [e.self]: "talent-option-roster",
  [e.offPlatform]: "talent-option-offplatform"
}, w = i(
  ({
    enableOffPlatformOption: r,
    defaultValue: c = e.agency,
    onChange: m,
    trackId: g = "",
    optionTrackIds: o,
    prefix: f = "",
    iconStyles: u = {},
    menuButtonProps: y = {},
    ...s
  }) => {
    const P = D(() => {
      const a = [
        {
          label: "Agency Roster",
          value: e.agency,
          icon: /* @__PURE__ */ t(b, { boxSize: 4 }),
          trackId: l(
            f,
            (o == null ? void 0 : o[e.agency]) || n[e.agency]
          ),
          onChange: () => m(e.agency)
        },
        {
          label: "My Roster",
          value: e.self,
          icon: /* @__PURE__ */ t(S, { boxSize: 4 }),
          trackId: l(
            f,
            (o == null ? void 0 : o[e.self]) || n[e.self]
          ),
          onChange: () => m(e.self)
        }
      ];
      return r && a.push({
        label: "Off-platform talent",
        value: e.offPlatform,
        icon: /* @__PURE__ */ t(h, { boxSize: 4 }),
        trackId: l(
          f,
          (o == null ? void 0 : o[e.offPlatform]) || n[e.offPlatform]
        ),
        onChange: () => m(e.offPlatform)
      }), a;
    }, [r]);
    return /* @__PURE__ */ t(
      R,
      {
        options: P,
        defaultValue: c,
        trackId: l(f, g),
        listProps: {
          minWidth: "162px"
        },
        iconStyles: u,
        menuButtonProps: y,
        ...s
      }
    );
  }
);
export {
  w as TalentDropdown
};
//# sourceMappingURL=TalentDropdown.es.js.map
